import * as React from 'react'
import ShortcutAlert from '../../ui-kit/alerts/shortcut'

interface Props {
   errorStatusCode?: number
}

const TranslationAlerts = ({ errorStatusCode }: Props) => {
   const isRateLimited = errorStatusCode === 429
   // Only reached when the sign-in screen was dismissed: the API layer offers
   // it on every 403 and replays the request once signed in, so a 403 that gets
   // this far is a choice, not a dead end.
   const isSignInRequired = errorStatusCode === 403
   // Neither is a failure — both lift on their own — so they get the calmer
   // treatment rather than the red error one.
   const isWaiting = isRateLimited || isSignInRequired
   const title = isRateLimited ? 'Please Wait' : isSignInRequired ? 'Sign In to Continue' : 'Error'
   const background = isWaiting ? '#2196f3' : '#f44336'
   const icon = isWaiting ? 'info_outline' : 'error_outline'

   return (
      <div className="container text-center mx-auto">
         <ShortcutAlert
            isShown={true}
            title={title}
            background={background}
            color="#fff"
            icon={icon}
         >
            {errorStatusCode === 413 && (
               <span>
                  Sorry, this text is more than can be processed at once. Please try a smaller
                  amount.
               </span>
            )}

            {isRateLimited && (
               <span>The server is currently under heavy load. Please try again soon.</span>
            )}

            {isSignInRequired && (
               <span>
                  Free translations are busier than usual, so the last of the capacity is being held
                  for signed-in users. Sign in to keep translating, or try again in a few minutes.
               </span>
            )}

            {errorStatusCode && errorStatusCode !== 413 && !isWaiting && (
               <span>
                  Sorry, an error occurred and we couldn't process your text. Please try again.
               </span>
            )}
         </ShortcutAlert>
      </div>
   )
}

export default TranslationAlerts
